<template>
  <div>
    <label for="planning-day">{{ $t('insights.ui.timespan.label') }}</label>
    <select name="" class="form-control" id="planning-day" @change=emitConfig v-model="config.dayDifference">
      <option v-if="history" :value="{start: 0, end: -7}">{{ $t('insights.ui.timespan.lastSevenDays') }}</option>
      <option v-if="history" :value="{start: -2, end: -2}">{{ $t('insights.ui.timespan.dayBeforeYesterday') }}</option>
      <option v-if="history" :value="{start: -1, end: -1}">{{ $t('insights.ui.timespan.yesterday') }}</option>
      <option v-if="today" :value="{start: 0, end: 0}">{{ $t('insights.ui.timespan.today') }}</option>
      <option v-if="future" :value="{start: 0, end: 5}">{{ $t('insights.ui.timespan.nextFiveDays') }}</option>
      <option v-if="future" :value="{start: 0, end: 7}">{{ $t('insights.ui.timespan.nextWeek') }}</option>
      <option v-if="future" :value="{start: 0, end: 14}">{{ $t('insights.ui.timespan.nextTwoWeeks') }}</option>
    </select>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";

export default {
  mixins: [generalMethods],
  name: "WeekSelect",
  props: ['editing', 'currentConfig', 'future', 'today', 'history'],
  data() {
    return {}
  },
  created(){
    this.config = this.currentConfig
  }

}
</script>

<style scoped>

</style>